import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/repasse-atendimento`;

export const createRepasse = async (obj) => {
  return await axios.post(`${httpUrl}`, obj).then((response) => response);
};

export const getRepassePorPacienteId = async (idPaciente) => {
  return await axios.get(`${httpUrl}/paciente/${idPaciente}`).then((response) => response);
};

export const getRepasseStatusSolicitadoPorPacienteId = async (idPaciente) => {
  return await axios.get(`${httpUrl}/repasse-status-solicitado/${idPaciente}`).then((response) => response);
};

export const getRepasseByIdRegistroAtendimento = async (idRegistroAtendimento) => {
  return await axios.get(`${httpUrl}/registro-atendimento/${idRegistroAtendimento}`).then((response) => response);
};

export const getRepasseByCpfProf = async (cpfProf) => {
  return await axios.get(`${httpUrl}/por-cpf-prof`, { params: { cpf: cpfProf } }).then((response) => response);
};

export const getRepasseByCpfProfAndSituacao = async (cpfProf) => {
  return await axios.get(`${httpUrl}/por-cpf-prof-situacao`, { params: { cpf: cpfProf } }).then((response) => response);
};

export const responderRepasse = async (obj) => {
  return await axios.post(`${httpUrl}/responder-repasse`, obj).then((response) => response);
};
